export default __webpack_public_path__ + "static/media/goshen22.f7caee8e.jpg";